import styled from 'styled-components';
import Food from '../../assets/img/food.png';

export const DiscountContainer = styled.div`
  position: relative;
  
  width: 317px;
  height: 120px;
  
  background: transparent no-repeat center / 100% 100%;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='317' height='120' fill='none'%3E%3Cpath fill='url(%23paint0_linear)' fill-rule='evenodd' d='M.6 114a6 6 0 0 0 6 6h143.7l4.4-5.9a2 2 0 0 1 3.2 0l4.4 5.9h148.3a6 6 0 0 0 6-6V6a6 6 0 0 0-6-6H162.3l-4.4 5.9a2 2 0 0 1-3.2 0L150.3 0H6.6a6 6 0 0 0-6 6v108z' clip-rule='evenodd'/%3E%3Cpath fill='%23FAFAFA' fill-rule='evenodd' d='M157 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-2 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm2 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0z' clip-rule='evenodd'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear' x1='-157.4' x2='-77.8' y1='60' y2='-149.8' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%232DB9FE'/%3E%3Cstop offset='1' stop-color='%234EDBFC'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
  
  filter: drop-shadow(0 4px 16px rgba(30, 182, 255, 0.2));
`;

export const DiscountSection = styled.section`
  margin-bottom: 30px;
  
  @media (min-width: 768px) {
    grid-column: ${({ twoColumn }) => twoColumn ? '1/3' : 2};
    margin-bottom: 0;
  }
`;

export const DiscountHeading = styled.h2`
  margin: 0;
  margin-bottom: 10px;
  padding: 0;
  
  font-size: 22px;
  line-height: 28px;
  
  @media (min-width: 768px) {
    font-size: 24px;
    line-height: 30px;
  }
`;

export const DiscountDescription = styled.p`
  margin: 0;
  margin-bottom: 30px;
  padding: 0;
  
  font-size: 14px;
  line-height: 20px;
  
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 18px;
  }
`;

export const DiscountDish = styled.span`
  position: absolute;
  bottom: 0;
  left: 0;
  
  width: 132px;
  height: 134px;
  font-size: 0;
  
  background: transparent url(${Food}) no-repeat center / contain;
  user-select: none;
  pointer-events: none;
`;

export const DiscountCodeContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 50%;
  height: 100%;
  
  color: ${({ theme }) => theme.white};
`;

export const DiscountCode = styled.p`
  margin: 0;
  margin-bottom: 5px;
  padding: 0;
  
  font-weight: 700;
  line-height: 1;
  font-size: 30px;
  text-transform: uppercase;
`;

export const DiscountSub = styled.p`
  margin: 0;
  padding: 0;
  
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  
  user-select: none;
`;
